import {Config} from "../models/Config";

const config: Config = {
    apiUrl: "https://api.linkandgo.co.il",
    contentUrl: "https://d2l4ox4cfsdkfa.cloudfront.net"
};
export default config;
